// Format currency
export const formatCurrency = (amount) => {
  if (!amount && amount !== 0) return 'N/A';
  
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0
  }).format(amount);
};

// Format date
export const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('en-IN', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(date);
};

// Get payment status color
export const getStatusColor = (status) => {
  switch (status?.toLowerCase()) {
    case 'completed':
    case 'paid':
    case 'success':
      return 'green';
    case 'pending':
    case 'processing':
      return 'yellow';
    case 'failed':
    case 'cancelled':
    case 'rejected':
      return 'red';
    default:
      return 'gray';
  }
};

// Generate CSV from data
export const generateCSV = (data, columns) => {
  if (!data || !data.length) return '';
  
  // Create CSV header
  const header = columns.map(col => `"${col.label}"`).join(',');
  
  // Create CSV rows
  const rows = data.map(item => {
    return columns.map(col => {
      let value = item[col.key];
      
      // Format value based on type
      if (col.type === 'currency') {
        value = formatCurrency(value);
      } else if (col.type === 'date') {
        value = formatDate(value);
      }
      
      // Wrap in quotes to handle commas in values
      return `"${value || ''}"`;
    }).join(',');
  }).join('\n');
  
  return `${header}\n${rows}`;
};

// Download file
export const downloadFile = (content, fileName, contentType) => {
  const blob = new Blob([content], { type: contentType });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}; 